export interface PaymentCardToken {
  cardToken: string;
  cardLastFourDigits: string;
}

export const buildPaymentCardToken = (cardToken: string, cardLastFourDigits: string): PaymentCardToken => {
  return {
    cardToken,
    cardLastFourDigits,
  };
};

export interface PaymentCardTokenResponse {
  data?: PaymentCardToken;
  error?: {
    messages: string[];
  };
}
